import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class GetCMSDataService {
  private subject = new Subject<any>();

  private userDetails = new BehaviorSubject({ data: null, index: 0 });
  userDetail = this.userDetails.asObservable();

  constructor(private http: HttpClient) {
    /* this.getJSON().subscribe(data => {
    }); */
  }
  /* public getJSON(): Observable<any> {
    return this.http.get('./app/core/cms/headerMock.json');
  } */
  sendButtonStatus(userData: any) {
    this.subject.next({ data: userData });
  }

  getButtonStatus(): Observable<any> {
    return this.subject.asObservable();
  }

  sendUserData(userData: any) {
    this.userDetails.next(userData);
  }
}
